import { Layout } from "~landing/components/layout";
import { Privacy } from "~landing/components/privacy/privacy";

export function PrivacyPolicy() {
	return (
		<Layout>
			<main>
				<Privacy />
			</main>
		</Layout>
	);
}
